import { useEffect } from 'react';
import { siteContent } from '../../data/products';
import { useContent } from '../../context/ContentContext';

const setMeta = (selector, attribute, value) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement('meta');
    const [name, key] = selector.match(/\[(.+?)="(.+?)"\]/)?.slice(1) || [];
    if (name && key) node.setAttribute(name, key);
    document.head.appendChild(node);
  }
  node.setAttribute(attribute, value);
};

const Seo = () => {
  const { revision } = useContent();
  useEffect(() => {
    const { brand, contact, seo } = siteContent;
    const configuredUrl = process.env.REACT_APP_SITE_URL || seo.siteUrl;
    const siteUrl = (configuredUrl || window.location.origin).replace(/\/$/, '');
    const shareImage = seo.shareImage.startsWith('http') ? seo.shareImage : `${siteUrl}${seo.shareImage}`;

    document.title = seo.title;
    setMeta('meta[name="description"]', 'content', seo.description);
    setMeta('meta[name="theme-color"]', 'content', seo.themeColor);
    setMeta('meta[property="og:title"]', 'content', seo.title);
    setMeta('meta[property="og:description"]', 'content', seo.description);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[property="og:url"]', 'content', `${siteUrl}/`);
    setMeta('meta[property="og:image"]', 'content', shareImage);
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:image"]', 'content', shareImage);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${siteUrl}/`;

    let structuredData = document.getElementById('kriams-jsonld');
    if (!structuredData) {
      structuredData = document.createElement('script');
      structuredData.id = 'kriams-jsonld';
      structuredData.type = 'application/ld+json';
      document.head.appendChild(structuredData);
    }
    structuredData.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Bakery',
      name: brand.name,
      alternateName: `${brand.name} — ${brand.tagline}`,
      url: `${siteUrl}/`,
      telephone: `+${contact.whatsappNumber}`,
      servesCuisine: 'Bakery',
      priceRange: seo.priceRange,
      address: contact.address,
      areaServed: contact.serviceArea,
      sameAs: [contact.instagramUrl].filter(Boolean),
      image: shareImage
    });
  }, [revision]);

  return null;
};

export default Seo;
